import React from 'react';
import Home_banner from "../components/Home_banner";
import Home_Service_Section from "../components/Home_Service_Section";
import FooterOne from "../footer/FooterOne";
import HomeAbout from '../components/HomeAbout';
import HomeWorkProcess from '../components/HomeWorkPorcess';
import BrandSection from '../components/BrandSliderOne';
import HomePortfolio from '../components/HomePortfolio';
import FeaturesOne from '../components/FeaturesOne';
import TestimonialOne from '../components/TestimonialOne';
import BlogHome from '../components/BlogHome';
import OnePageHeaderOne from '../header/OnePageHeaderOne';
import ContactForm from '../components/ContactForm'
export default function OnePageOne() {
	
  	return (
	<>
	
	<OnePageHeaderOne/>
	<main>		
		<Home_banner />		
		<HomeAbout/>		
		<Home_Service_Section />		
		<HomeWorkProcess/>	
		<BrandSection/>
		<HomePortfolio/>	
		<FeaturesOne/>
		<TestimonialOne/>
		<BlogHome/>
		<section id="contact" className="contact-area pt-120 pb-90 pt-md-60 pb-md-60 pt-xs-60 pb-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<div className="section-title mb-60">
							<p className="fs-14 lh-1 mb-15">Get In Touch</p>
							<h2 className="sect-title lh-1">Let's help you!</h2>
						</div>
						<ContactForm />
					</div>
					<div className="col-lg-6">
						<div className="contact-short-info pr-50 pr-lg-0 pr-md-0 pr-xs-0 pl-80 pl-lg-0 pl-md-0 pl-xs-0">
							<div className="section-title mb-30">
								<p className="fs-14 lh-1 mb-15">Contact Us</p>
								<h2 className="sect-title lh-1">Catch us for help</h2>
							</div>
							<div className="adress-box">
								<div className="icon-link">
									<i className="fas fa-phone"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Phone Number</p>
									<h6>890. 908. 645. 45, 908 (908) 897 89</h6>
								</div>
							</div>
							<div className="adress-box ab-2">
								<div className="icon-link">
									<i className="fas fa-envelope"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Email Address</p>
									<h6>info@webmail.com, jobs@webexample.com</h6>
								</div>
							</div>
							<div className="adress-box">
								<div className="icon-link">
									<i className="fas fa-map-marker-alt"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Office Address</p>
									<h6>12/A, Rosalina Halim Tower, New York, USA</h6>
								</div>
							</div>							
						</div>
					</div>
				</div>
			</div>
		</section>
    	<section className="contact-map-area">
			<div className="container-fluid px-0">
				<div className="contact-map">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14586.16663307975!2d90.3865062!3d23.941279099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641645837442!5m2!1sen!2sbd"
						 loading="lazy"></iframe>
				</div>
			</div>
		</section>
	</main>
	<FooterOne />
	
</>
  )
}
